import {
  TREQUEST_AuditLogsDetails,
  TAqlListingPagesType,
  TAQLStore,
  TAqlStoreLockedBy,
  TAqlDB,
  TAqlEvent,
  TAQLAuditMetaData,
  TAuditLog,
  TSingleAuditDetail,
} from '@monorepo/types';
import { Action } from '@ngrx/store';

export enum TAQLStoreActionsType {
  NoAqlAction = 'NoAqlAction',
  UpdateAqlStoreLockDetails = 'UpdateAqlStoreLockDetails',
  AcquireLockAndThenInitAqlStore = 'AcquireLockAndThenInitAqlStore',
  AqlNoAction = 'AqlNoAction',
  InitAqlStoreAndThenReleaseLock = 'InitAqlStoreAndThenReleaseLock',
  UpdateAqlStoreAndReleaseLock = 'UpdateAqlStoreAndReleaseLock',
  GetAuditListingMappedWithLocalStorage = 'GetAuditListingMappedWithLocalStorage',
  AquireLockSaveAndUpdateCompletedEventsAndrecentCateGoryList = 'AquireLockSaveAndUpdateCompletedEventsAndrecentCateGoryList',
  AquireLockUpdateSavedEventsAndrecentCateGoryList = 'AquireLockUpdateSavedEventsAndrecentCateGoryList',
  AquireLockAndDeleteAudit = 'AquireLockAndDeleteAudit',
  UpdateAqlStoreAndReleaseLockAndFetchWeeklyFailedEvents = 'UpdateAqlStoreAndReleaseLockAndFetchWeeklyFailedEvents',
  AquireLockAndUpdateWeeklyfailedEvents = 'AquireLockAndUpdateWeeklyfailedEvents',
  UpdateWeeklyfailedEventsAndReleaseLock = 'UpdateWeeklyfailedEventsAndReleaseLock',
}

export class AquireLockAndUpdateWeeklyfailedEvents implements Action {
  readonly type = TAQLStoreActionsType.AquireLockAndUpdateWeeklyfailedEvents;
  constructor(public data: TAuditLog[]) {}
}

export class UpdateWeeklyfailedEventsAndReleaseLock implements Action {
  readonly type = TAQLStoreActionsType.UpdateWeeklyfailedEventsAndReleaseLock;
  constructor(public data: TAuditLog[]) {}
}

export class UpdateAqlStoreAndReleaseLockAndFetchWeeklyFailedEvents implements Action {
  readonly type = TAQLStoreActionsType.UpdateAqlStoreAndReleaseLockAndFetchWeeklyFailedEvents;
  constructor(public aqlDB: TAqlDB) {}
}
export class GetAuditListingMappedWithLocalStorage implements Action {
  readonly type = TAQLStoreActionsType.GetAuditListingMappedWithLocalStorage;
  constructor(
    public payload: TREQUEST_AuditLogsDetails,
    public listingType: TAqlListingPagesType,
    public showLoader: boolean,
  ) {}
}

export class UpdateAqlStoreLockDetails implements Action {
  readonly type = TAQLStoreActionsType.UpdateAqlStoreLockDetails;
  constructor(public lockDetails: TAQLStore['lockDetails']) {}
}

export class AcquireLockAndThenInitAqlStore implements Action {
  readonly type = TAQLStoreActionsType.AcquireLockAndThenInitAqlStore;
  constructor(public lockFor: TAqlStoreLockedBy) {}
}

export class AqlNoAction implements Action {
  readonly type = TAQLStoreActionsType.AqlNoAction;
  constructor() {}
}

export class InitAqlStoreAndThenReleaseLock implements Action {
  readonly type = TAQLStoreActionsType.InitAqlStoreAndThenReleaseLock;
  constructor() {}
}

export class UpdateAqlStoreAndReleaseLock implements Action {
  readonly type = TAQLStoreActionsType.UpdateAqlStoreAndReleaseLock;
  constructor(public aqlDB: TAqlDB) {}
}

export class AquireLockSaveAndUpdateCompletedEventsAndrecentCateGoryList implements Action {
  readonly type = TAQLStoreActionsType.AquireLockSaveAndUpdateCompletedEventsAndrecentCateGoryList;
  constructor(public singleAuditDetail: TSingleAuditDetail, public loaderMessage: string) {}
}

export class AquireLockUpdateSavedEventsAndrecentCateGoryList implements Action {
  readonly type = TAQLStoreActionsType.AquireLockUpdateSavedEventsAndrecentCateGoryList;
  constructor(public bulkEvent: TAqlEvent) {}
}

export class AquireLockAndDeleteAudit implements Action {
  readonly type = TAQLStoreActionsType.AquireLockAndDeleteAudit;
  constructor(public aqlAuditMetaData: TAQLAuditMetaData) {}
}

export class NoAqlAction implements Action {
  readonly type = TAQLStoreActionsType.NoAqlAction;
  constructor() {}
}

export type TAqlStoreActions =
  | UpdateAqlStoreLockDetails
  | AcquireLockAndThenInitAqlStore
  | AqlNoAction
  | InitAqlStoreAndThenReleaseLock
  | UpdateAqlStoreAndReleaseLock
  | GetAuditListingMappedWithLocalStorage
  | AquireLockSaveAndUpdateCompletedEventsAndrecentCateGoryList
  | AquireLockUpdateSavedEventsAndrecentCateGoryList
  | AquireLockAndDeleteAudit
  | UpdateAqlStoreAndReleaseLockAndFetchWeeklyFailedEvents
  | AquireLockAndUpdateWeeklyfailedEvents
  | UpdateWeeklyfailedEventsAndReleaseLock
  | NoAqlAction;
